import { CommonErrorDetailsType } from '@elearning-platform/api-types/interfaces';

export class FrontendApiError {
  public responseCode: number;
  public endpointUrl: string | undefined;
  public requestHasAuthorization: boolean;
  public message: string;
  public details: CommonErrorDetailsType | null;

  constructor(
    message: string,
    responseCode: number,
    endpointUrl: string | undefined,
    requestHasAuthorization: boolean,
    details: CommonErrorDetailsType | null,
  ) {
    this.responseCode = responseCode;
    this.endpointUrl = endpointUrl;
    this.requestHasAuthorization = requestHasAuthorization;
    this.message = message;
    this.details = details;
  }
}
